<div class="social-login-container">
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="googleBtnTrigger"
    [cdkConnectedOverlayOpen]="showNonSaasGooglePopover"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    [cdkConnectedOverlayPositions]="popoverPositions"
    (backdropClick)="showNonSaasGooglePopover = false"
  >
    <div class="social-login-popover">
      <span class="popover-title" translate="AUTH.LOGIN.NON_SAAS_POPOVER.TITLE"></span>

      <div class="popover-actions">
        <button
          mat-flat-button
          color="primary"
          type="button"
          (click)="socialLogin(providers.Google); showNonSaasGooglePopover = false"
        >
          <span translate="AUTH.LOGIN.NON_SAAS_POPOVER.YES_OPTION"></span>
        </button>

        <button mat-stroked-button type="button" class="popover-link" (click)="onContactClick()">
          <span translate="AUTH.LOGIN.NON_SAAS_POPOVER.NO_OPTION"></span>
        </button>
      </div>

      <div class="popover-arrow"></div>
    </div>
  </ng-template>

  <!-- facebook -->
  <!-- <div class="facebook-auth-button sso-auth-button" (click)="onClick(providers.Facebook)">
    <gb-icon icon="logo-facebook"></gb-icon>
    <span [translate]="getLabel(providers.Facebook)"> </span>
  </div> -->

  <!-- google -->
  <div
    class="google-auth-button sso-auth-button"
    cdkOverlayOrigin
    #googleBtnTrigger="cdkOverlayOrigin"
    (click)="onClick(providers.Google)"
  >
    <gb-google-icon></gb-google-icon>
    <span [translate]="getLabel(providers.Google)"></span>
  </div>

  <!-- microsoft -->
  <!-- <div class="microsoft-auth-button sso-auth-button" (click)="onClick(providers.Microsoft)">
    <gb-microsoft-icon></gb-microsoft-icon>
    <span [translate]="getLabel(providers.Microsoft)"> </span>
  </div> -->

  <!-- apple -->
  <!-- <div class="apple-auth-button sso-auth-button" (click)="onClick(providers.Apple)">
    <gb-icon icon="logo-apple"></gb-icon>
    <span [translate]="getLabel(providers.Apple)"> </span>
  </div> -->
</div>
